<!--
 * @Description:

 * @Date: 2018-12-21 17:03:28
 * @LastEditors: wjx
 * @LastEditTime: 2019-06-22 13:32:02
 -->
<template>
  <div class="settle-center">
    <el-dialog
      custom-class="settle-center-dialog"
      :visible.sync="showDialog"
      :show-close="false"
      :width="`${width}px`"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="settle-center-dialog-title">
        <div class="back" v-if="back"></div>
        <div class="text">{{ title }}</div>
        <div class="close" @click="cancel"></div>
      </div>
      <div class="settle-center-dialog-body">
        <slot name="content"></slot>
        <div class="settle-center-dialog-footer" v-if="!hideBtn">
          <el-button @click="cancel" v-if="!hideCancel" class="cancel btn">
            {{ cancelText }}
          </el-button>
          <el-button @click="confirm" type="primary" class="btn">
            {{ confirmText }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 500
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    title: String,
    back: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDialog: true
    };
  },
  computed: {},
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    confirm() {
      this.$emit('callback', 'success');
    },
    cancel() {
      this.closeDialog();
      this.$emit('callback', 'close');
    }
  },
  created() {},
  beforeDestroy() {},
  filters: {}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.settle-center {
  background: #fff;
  min-height: 100%;
  .settle-center-dialog-title {
    position: relative;
    .back {
      background-image: url(data:image/png;base64,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);
      width: 20px;
      height: 20px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
    }
    .text {
      font-size: 24px;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
    }
    .close {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAM0ElEQVR4Xu3dX4hcVx0H8POb3aSZbYxR6ktFUzAYJT4IIpjiw6gJu+euSVMo4oOCTxGpimBqHgRFH0SjVWgLivjmSzFC0zSZM2ETGf9gXhr61BLRCkpbTUADbZ3Jupv9ySSz7nR3Z+bc8//e8+3rnnPuOd/f+fR3J7vZkMB/SAAJjE2AkA0SQALjEwAQ3A4kMCEBAMH1QAIAgjuABMwSQAcxyw2zMkkAQDIpNI5plgCAmOWGWZkkACCZFBrHNEsAQMxyw6xMEgCQTAqNY5olACBmuWFWJgkASCaFxjHNEgAQs9wwK5MEACSTQuOYZgkAiFlumJVJAgCSSaFxTLMEAMQsN8zKJAEAyaTQOKZZAgBilhtmZZIAgGRSaBzTLAEAMcsNszJJAEAyKTSOaZYAgJjlhlmZJAAgmRQaxzRLAEDMcsOsTBIAkEwKjWOaJQAgZrlhViYJJAlkfn7+4MzMTLPX613rdrtvZlKLLI957Nixt62urh5g5p5S6qXUQkgCiJRyjxDiBBE9LIR4cDQkZn5RCHF+dXX1iaWlpddSCxD7KZ9AURT7hBCPCiE+LYT44KZ6/4GInun1ej9P4X+O0YEURfEFZn6KiO6dFjUzn1ZKnZo2Dl9PNwEp5RNE9BWNHb6xtrZ2otPpPK0x1tuQqECklN8goh+UPN2zvV7vs91u91bJeRgeMYFWq7Vrbm7u10KIxTLbYObHlFI/KjPH5dhoQIqieEgIcdbwMB1mPq6UWjacj2kBE5BS3kNEg1ovmDx2bW1tsdPptE3m2s6JAqTVau2dm5v7qxDiHRYHABKL8EJNtcUx3OfN2dnZfefOnXsj1L7XnxMFSFEUp4UQj9kelpkv9vv943jdsk3Sz/zBa1Wz2TxLRPO2T2Dm7yqlvm27Ttn5UYBIKV8lovvLbnbMeHQSR0G6XMZR5/j/lgZ/mqmU+pDLPeqsFRzIkSNH7t+xY8erOpvTHYNOoptUmHEuO8fojmdnZ/eEfs0KDmRxcfEjzPy8h1Khk3gIteySrjvH6POZeb9S6uWye7IZHxzIwsLCxxuNxu9tNj1uLjqJj1T11/TVOdZ3wMwHQ3+3PQaQA41G45p+7KVHopOUjsx+gs/Osb675eXl+y5fvvwv+93qrxAciBCiIaV8Xec75/rH2DISSCzCKzs1BA5mfk0p9e6ye7MdHwOIkFKeIaJHbDc/aT5et3ymu7G279eqkderJ5VSXw1zqo2nRAFSFMWHhRAvBDgsOonHkEN0jsH2mXmZiB5ot9v/9HicbZeOAmSwEynlD4nopO8Do5P4SThU5xgCOamUetzPSSavGg3IEMkFIip8HxxI3CYcEocQ4tl2u33c7Qn0V4sN5B4hRJuIPqm/ZeOReN0yjm5jYqjXqmHn+I0Qooj5Q6lRgQy7CJA4uLghlsgNxyDT6ECAJMTVtn9GjjiSAQIk9hfY5wq54kgKCJD4vOLma+eMIzkgQGJ+kX3MzB1HkkCAxMdVL78mcNzNLIkP6duVb1Ag/BFw+YvtYgZwbKSYLBB0EhdXvfwawPHWzJIGAiTlL7jNDODYml7yQIDE5srrzwWO7bOqBBAg0b/oJiOBY3xqlQECJCZXf/oc4JicUaWAAMn0C19mBHBMT6tyQIBkelF1RgCHTkoJfx9k2vbxfZJpCY3/OnDoZ1fJDrJ+PCDRL/RoZja/SLrME5k5+t/nKLPf7cZWGghet8qVH52jXF6D0ZUHAiR6RQcOvZw2j6oFECCZXHzgMMNRmw6CzyT4QG5OYPLM2nQQINlaaHQOeza1A4LXrbuXAjjscdTuFWs0kpz/CBg43OCoNZBcOwlwuMNReyC5IQEOtziyAJILEuBwjyMbIHVHAhx+cGQFpK5IgMMfjuyA1A0JcPjFkSWQuiABDv84sgVSdSTAEQZH1kCqigQ4wuHIHkjVkABHWBwAMsy7Cj+WAhzhcQDISOYpIwGOODgAZFPuKSIBjng4AGSb7FNCAhxxcQDImPxTQAIc8XEAyIQaxEQCHGngAJApdYiB5E5RiM4KIRZ8X5M6/N4q3xnV8q/cugzt0KFDzb179z5HRJ9yue52azHzxSGQed/PEkIs9Xq9Y91u91aAZ1X2EQCiUbrAnURjR3ZD0Dn08wMQzazqggQ4NAs+HAYgJfKqOhLgKFFsACkf1mBGVZEAh1m90UEMcqsaEuAwKDI6iHloVeokwGFXZ3QQi/xS7yTAYVFcdBD78FLuJMDhpr7oIA5yTK2TAIeDoqKDuAsxpU4CHG7rig7iMM/YnQQ4HBYTHcR9mDE7CXD4qSc6iIdcQ3cS4PBQRHQQf6ECiL9sQ6+MDuI48dA41rePLuK4kOgg7gONhQNI3NdyfUV0EEfZxsYBJI4KuWkZAHGQayo4gMRBMQHEbYip4QASt/VFB7HIM1UcQGJRVHQQN+GljgNI3NQZHcQgx6rgABKD4qKD2IVWNRxAYldvdJAS+VUVB5CUKDI6iFlYVccBJGZ1RwfRyK0uOIBEo9joIOVCarVau5rN5nn86tFyudVlNDrIhEoG7hwdZj4+2A5+eXU6vABkTC1i4FBKLQ+2g3/+AEDSSWCbncTEsb4dIEnjiqCDbKpDCjiAJA0cd15309lK/J2khANI4t8HABmpQYo4gCQ+EnSQ8L+x/c6fVq1/INe9AvhMopuU23HZA0m5c2wuNZC4vfw6q2UNpEo48Lqlc53dj8kWSBVxAIl7ANNWzBJIlXEAybQr7fbr2QGpAw4gcYtg0mpZAakTDiAJgyQbIHXEAST+kWQBpM44gMQvktoDyQEHkPhDUmsgOeEAEj9IagskRxxA4h5JLYHkjANI3CKpHRDg2Lgg+Nkteyy1AgIcWy8EkNghqQ0Q4Bh/EYDEHEktgADH9AsAJNMz2m5E5YEAh37hgUQ/q/WRlQYCHOULDiTlMqssEOAoV+jR0UCin10lgQCHfoHHjQyN5MaNGwtXr15dsd952BUqBwQ43F2QkEiEEJ3r168fqxqSSgEBDnc4YnzHvYpIKgMEONzjAJLpmVYCCHBML6TtCLxubZ9g8kCAw/bq688Hkq1ZJQ0EOPQvt6uRQPLWJJMFAhyurnz5dYBkI7MkgQBH+UvtegaQ3E00OSDA4fqqm68HJIkBAQ7zy+xrZu5IkukgwOHrituvmzOSJIAAh/0l9r1CrkiiAwEO31fb3fo5IokKBDjcXd5QK+WGJCqQoijOCyEWfReXmS/2+/3j3W73lu9n5bB+q9Xa1Ww2zxLRvO/zMvM5pdRDvp8zbv1oQKSU3yGib/k+OHD4STgwkm8qpb7n5ySTV40CREr5PiL6kxBixvOhjf7BTM97qs3yoV63mHllZWVl/6VLl/4eOrwoQIqi+KUQ4nM+D4vO4TPdjbVDdRJm/plS6kthTrXxlBhAGlLKfxPR2z0eFp3DY7iblw7RSZj5FaXUewIe686jggMZvl79xeNBgcNjuOOWDoGEiN554cKFmyGPFxzIwsLCoUaj8UdPhwQOT8HqLOsbycrKyvuXlpb+rLMXV2OCA5FSfoyIrrg6wMg6wOEh1LJL+kTCzPuVUi+X3ZPN+OBADh8+/N6dO3f+zWbTm+fiA7nLNO3X8vXB/ebNm3NXrlzp2+9Qf4XgQAZbk1LeIKJ36W9z4kh0DkdBulzGdSdh5ueVUh91uUedtWIBeZKIvqyzwUlj0DlsE/Q732UnYeZTSqnTfne8dfUoQI4ePXrf7du3B69ZcxYHRuewCC/UVBedhJn/sXv37gfOnDnz31D7Xn9OFCDD16xHiOiM4YGBwzC4GNNskDAzCyE+oZT6bYy9RwMyRHKKiL5f5uDM/Fy/3/8MfvCwTGrxxw5ft35FREdL7ubr7Xb7xyXnOBseFcjgFEVRfJ6Zf0pE9047FTM/rpQ6OW0cvp5uAlLKnxDR16btkJlfZ+Yvdjqdp6eN9fn16ECGnWSPEOIEET0shHhw9MDM/KIQYvBj8U8ppV7xGQbWDpNAURT7hBCPCiEG3eQDm576O2Z+pt/v/6Lb7b4ZZkfjn5IEkM3bm5+fPzgzM9Ps9XrXUggpdpHq/Hwp5R5mPkBE/1FKvZTaWZMEklpI2E++CQBIvrXHyTUSABCNkDAk3wQAJN/a4+QaCQCIRkgYkm8CAJJv7XFyjQQARCMkDMk3AQDJt/Y4uUYCAKIREobkmwCA5Ft7nFwjAQDRCAlD8k0AQPKtPU6ukQCAaISEIfkmACD51h4n10gAQDRCwpB8EwCQfGuPk2skACAaIWFIvgkASL61x8k1EgAQjZAwJN8EACTf2uPkGgkAiEZIGJJvAgCSb+1xco0EAEQjJAzJNwEAybf2OLlGAgCiERKG5JsAgORbe5xcIwEA0QgJQ/JNAEDyrT1OrpHA/wCOHUJQDW15gwAAAABJRU5ErkJggg==);
      width: 20px;
      height: 20px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
  .settle-center-dialog-body {
    width: 100%;
    height: 320px;
    padding: 0 40px;
    position: relative;
  }
  .settle-center-dialog-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    padding-top: 25px;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    .btn {
      min-width: 104px;
    }
    .cancel {
      border: none;
      color: #fff;
      background: #c6cbd4;
    }
  }
}
</style>

<style lang="scss">
.settle-center {
  .settle-center-dialog {
    border-radius: 12px;
    .el-dialog__header {
      padding-top: 30px;
    }
  }
}
</style>
